import {
  LogicalPolicyFormValues,
  PolicyObject,
} from '@components/EntityDrawers/constants/empty-objects';
import {
  CommonKeys,
  LogicPhysicalFormKeysType,
  LogicPhysicalKeys,
} from '@components/EntityDrawers/constants/keys';
import { LogicalKeys } from '@components/EntityDrawers/drawers/Logical/keys';
import { ShapeType } from '@constants/types';
import { PolicyYup } from '@constants/validation';
import { NameObjective } from '@store/services/nodes/types';
import { generateSchema, getDefs, getYups } from '@utils/drawers';
import { withId } from '@utils/helpers';
import * as yup from 'yup';

export type LogicalFormValues = yup.InferType<typeof validationSchema> & {
  [CommonKeys.Metrics]: NameObjective[];
  [LogicalKeys.Policies]: LogicalPolicyFormValues[];
};

export const validationSchema = generateSchema<
  ShapeType<LogicPhysicalFormKeysType>
>({
  ...getYups(...LogicPhysicalKeys),
  [LogicalKeys.Policies]: PolicyYup(),
});

export const defaultValues: LogicalFormValues = {
  ...getDefs(...LogicPhysicalKeys),
  [LogicalKeys.Policies]: [withId(PolicyObject)],
};
